import React, { useEffect, useState } from "react";
import {
	Link,
	useParams,
	useNavigate,
	useSearchParams,
} from "react-router-dom";
import { Form, Input, Row, Col, Space, Modal } from "antd";
import { InnerForm, ProductData, PublishSettings } from "./styles";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../utils/notificationToast";
import Main from "../../../../layout/main/Main";
import SignInTemplate from "../../../../layout/sign-in-template/SignInTemplate";
import COLORS from "../../../../layout/theme/colors/Colors";
import {
	get_category_by_id,
	update_category,
} from "../../../../../api/endpoints/categories";
import DebounceSelect from "../../../../common/debounce-select/DebounceSelect";
import { get_sale_departments } from "../../../../../api/endpoints/saledepartments";
import LoadingSkeleton from "./components/loading-skeleton/LoadingSkeleton";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Typo } from "../../../../layout/theme";
import PrimaryButton from "../../../../common/antd-buttons/PrimaryButton";
import DefaultButton from "../../../../common/antd-buttons/DefaultButton";

const GUTTER = 10;

export default function UpdateCategory() {
	const { id } = useParams();
	const [form] = Form.useForm();
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [saleDepartments, setSaleDepartments] = useState(null);
	const [submitting, setSubmitting] = useState(false);
	const [initialValues, setInitialValues] = useState(null);
	const navigate = useNavigate();

	useEffect(() => {
		const fetch_category_by_id = async () => {
			const data = await get_category_by_id(id);

			const category = {
				title: data.name,
			};

			setSaleDepartments(
				data.saleDepartments?.map((i) => ({
					value: i.saleDepartment.id,
					label: i.saleDepartment.name,
				})),
			);

			setInitialValues(category);
		};

		if (id) {
			fetch_category_by_id();
		}
	}, []);

	const fetch_sale_departments = async (term) => {
		const res = await get_sale_departments(term);

		return res.map((r) => ({
			label: r.name,
			value: r.id,
		}));
	};

	const onFinish = async (values) => {
		try {
			setSubmitting(true);

			const putData = {
				id,
				title: values.title,
				saleDepartments: saleDepartments?.map((i) => ({ id: i.value })),
			};

			await update_category(id, putData);

			openNotificationWithIcon(
				TYPE.SUCCESS,
				"Categoría actualizada con éxito",
				"La categoría se actualizó con éxito",
			);
			navigate(`/admin/categories?uri=${uri}`);
		} catch (error) {
			console.log(error);
			openNotificationWithIcon(
				TYPE.ERROR,
				"Error al actualizar la categoría",
				"Un error ocurrio al intentar actualizar la categoría, contacte con soporte a soporte@onetransfer.com.",
			);
		} finally {
			setSubmitting(false);
		}
	};

	const handleBack = () => {
		Modal.confirm({
			title: "¿Seguro que quiere volver sin guardar?",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content:
				"Si regresa sin guardar se perderán los datos que hayan sido modificados",
			okText: "Sí",
			okType: "danger",
			cancelText: "No",
			onOk: () => {
				navigate("/admin/categories?uri=" + uri);
			},
		});
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						{uri ? (
							<Link to={"/" + uri}>Configuración General</Link>
						) : (
							<Link to="/">Home</Link>
						)}
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.BreadcrumbItem>
						<Link to={"/admin/categories?uri=" + uri}>
							Listado de Categorias
						</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Editar Categoría
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				{!initialValues ? (
					<LoadingSkeleton />
				) : (
					<Form
						form={form}
						name="basic"
						onFinish={onFinish}
						autoComplete="off"
						requiredMark={false}
						layout="vertical"
						initialValues={initialValues}
					>
						<InnerForm>
							<ProductData>
								<Space
									direction="vertical"
									size="middle"
									style={{ display: "flex" }}
								>
									<Row gutter={GUTTER}>
										<Col span={22}>
											<Form.Item
												label={
													<label
														style={{ color: COLORS.Primary, fontWeight: "600" }}
													>
														Nombre
													</label>
												}
												name="title"
												rules={[
													{
														required: true,
														message: "Este campo es obligatorio",
													},
													{
														pattern: new RegExp(/^(?!\s*$)[a-zA-ZÀ-ÿ0-9\s]*$/),
														message:
															"No se aceptan caracteres especiales. Solo letras y numeros",
													},
												]}
											>
												<Input placeholder="Nombre" />
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={GUTTER}>
										<Col span={22}>
											<Form.Item
												label={
													<label
														style={{ color: COLORS.Primary, fontWeight: "600" }}
													>
														Rubros asociados
													</label>
												}
												name="categories"
											>
												<DebounceSelect
													fetchCallback={fetch_sale_departments}
													placeholder="Buscar rubro"
													onValuesChange={setSaleDepartments}
													initialValues={saleDepartments}
												/>
											</Form.Item>
										</Col>
									</Row>
								</Space>
							</ProductData>
							<PublishSettings>
								<Space
									direction="vertical"
									size="middle"
									style={{ display: "flex" }}
								>
									<Form.Item>
										<PrimaryButton htmlType="submit" loading={submitting} block>
											Guardar Cambios
										</PrimaryButton>
									</Form.Item>
									<DefaultButton
										loading={submitting}
										onClick={handleBack}
										block
									>
										<Typo type="danger" level={6}>
											Volver sin guardar
										</Typo>
									</DefaultButton>
								</Space>
							</PublishSettings>
						</InnerForm>
					</Form>
				)}
			</Main.Body>
		</Main>
	);
}
